import {
  Component,
  Inject,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';

import { ApplicationStateService } from 'src/app/services/application-state.service';
import { InvoicingService } from 'src/app/services/invoicing/invoicing.service';

import { Invoicing } from 'src/app/models/invoicing.interface';
import { AccountLocation } from 'src/app/models/location.interface';
import { LocationService } from 'src/app/services/location/location.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceHeaderComponent implements OnInit {
  @Input() showPayButton!: boolean | undefined;
  accountLocation$!: Observable<AccountLocation>;
  invoicing$!: Observable<Invoicing>;

  constructor(
    @Inject('INVOICE_TRACKING_KEY') private invoiceTrackingKey: string,
    public router: Router,
    private applicationState: ApplicationStateService,
    private invoicingService: InvoicingService,
    private locationService: LocationService
  ) {}

  ngOnInit(): void {
    this.invoicing$ = this.invoicingService.invoicing$;
    this.accountLocation$ = this.locationService.location$;
  }

  handlePayClick(): void {
    this.applicationState.nextStep('payment');
    this.router.navigateByUrl(`/invoice/${this.invoiceTrackingKey}/payment`);
  }
}
